import { GAME_WIDTH, GAME_HEIGHT, SCENE } from '../../config.js';
import { makeVisitScene } from './VisitSceneBase.js';
import { ROOM_PERSPECTIVE } from '../roomPerspective.mjs';
import { homeArrival } from '../homeLayout.mjs';

// Host's salon — same as the owner SalonScene: return to Home via the bottom edge.
export const VisitSalonScene = makeVisitScene({
  key: SCENE.VISIT_SALON,
  roomScene: 'SalonScene',
  areaKey: 'salon',
  bgKey: () => 'bg_salon',
  spawn: { x: GAME_WIDTH / 2, y: GAME_HEIGHT - 240 },
  perspective: ROOM_PERSPECTIVE.salon,
  exits: [
    { side: 'bottom', toScene: SCENE.VISIT_HOME, label: '{arrow_down} Dom', data: homeArrival('salon') },
  ],
});
